import React, { useEffect, useState } from "react";
import { getLink, permisions, toast } from "../../utils/helpers";
import useFilters from "../../hooks/useFilters";
import { request } from "../../utils/request";
import { apiRequest } from "../../hooks/apiRequest";
import PageHeader from "../general/PageHeader";
import { auth } from "../../utils/auth";
import { Link } from "react-router-dom";
import FiltersContainer from "../general/FiltersContainer";
import Pagination from "../general/Pagination";
import Modal from "../general/Modal";
import Dropdown from "../general/Dropdown";
import Loader from "../general/Loader";
import CrearCartaForm from "./components/CrearCartaForm";
import Select from 'react-select';

const Templates = () => {
    const [loading, setLoading] = useState(false);
    const [templates, setTemplates] = useState({});
    const [selected, setSelected] = useState();
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [showGenerarModal, setShowGenerarModal] = useState(false);
    const [deleting, setDeleting] = useState(false);

    const { handleFilterChange, filtersQuery } = useFilters({ buscar: null });

    const getTemplates = async (url) => {
        url = url ? url + "&limit=15" : `templates?limit=15`;

        setLoading(true);

        const response = await request(url);

        setTemplates(response);

        setLoading(false);
    };

    const openGenerarModal = (template) => {
        setSelected(template);

        setShowGenerarModal(true);
    };

    const closeGenerarModal = () => {
        setSelected();

        setShowGenerarModal(false);
    };

    const openDeleteModal = (template) => {
        setSelected(template);

        setShowDeleteModal(true);
    };

    const closeDeleteModal = () => {
        setSelected();

        setShowDeleteModal(false);
    };

    const eliminarTemplate = async () => {
        setDeleting(true);

        const response = await apiRequest({}, `templates/${selected.id}`, 'delete');

        if (response.success) {
            toast("Plantilla Eliminada", "success");
            
            closeDeleteModal();

            getTemplates(`templates${filtersQuery}`);
        } else {
            toast(response.data.message, "error");
        }

        setDeleting(false);
    };

    useEffect(() => {
        getTemplates(`templates${filtersQuery}`);
    }, [filtersQuery]);

    return <>
        <PageHeader title="Plantillas">
            {auth.canEdit(permisions.verCartas) && <Link
                className="au-btn au-btn-icon au-btn--green au-btn--small m-r-15 ml-auto mt-2 mt-lg-0"
                to={getLink("/cartas/plantillas/create")}
            >
                <i className="zmdi zmdi-plus" />
                Nueva Plantilla
            </Link>}
        </PageHeader>

        <FiltersContainer>
            <div className='col'>
                <label htmlFor='search'>Buscar</label>
                <input
                    name='buscar'
                    onChange={(e) => handleFilterChange("buscar", e?.target.value)}
                    type='search'
                    placeholder='Buscar...'
                    className='form-control'
                />
            </div>
            <div className="col-2">
                <label htmlFor='search'>Tipos</label>
                <Select
                    name="tipos"
                    isClearable
                    isMulti
                    menuPosition="fixed"
                    options={[
                        { value: "EMPLEADOS", label: "EMPLEADOS" },
                        { value: "CONTACTOS", label: "CONTACTOS" },
                        { value: "ESTUDIANTES", label: "ESTUDIANTES" },
                    ]}
                    onChange={(e) => handleFilterChange("tipos", e)}
                    styles={{
                        menuList: (styles) => ({
                            ...styles,
                            height: "120px",
                        }),
                    }}
                />
            </div>
        </FiltersContainer>

        <div className='row'>
            <div className='col-md-12'>
                <div>
                    <div className='table-data'>
                        <table className='table table-data2'>
                            <thead>
                                <tr>
                                    <th>Id</th>
                                    <th>Titulo</th>
                                    <th>Tipo</th>
                                    <th></th>
                                </tr>
                            </thead>

                            <tbody>
                                {loading
                                    ? (<tr className="tr-shadow"><td colSpan={4}><Loader /></td></tr>)
                                    : (templates?.data?.length
                                        ? templates.data.map((template) => (<tr className="tr-shadow" key={template.id}>
                                            <td>{template.id}</td>
                                            <td>{template.titulo}</td>
                                            <td>{template.tipo}</td>
                                            <td style={{width: '128px'}}>{auth.canEdit(permisions.verCartas) && <Dropdown
                                                    classes={{ button: "w-100", dropdownMenu: "align-right" }}
                                                    styles={{button: {height: "38px", lineHeight: "0px"}, dropdownMenu: {zIndex: "99"}}}
                                                >
                                                    <Link
                                                        className='dropdown-item'
                                                        data-toggle='tooltip'
                                                        data-placement='top'
                                                        title=''
                                                        data-original-title='Editar'
                                                        to={getLink(`/cartas/plantillas/${template.id}`)}>
                                                        Editar
                                                    </Link>

                                                    <button
                                                        className='dropdown-item'
                                                        data-toggle='tooltip'
                                                        data-placement='top'
                                                        title=''
                                                        data-original-title='Generar'
                                                        onClick={() => openGenerarModal(template) }>
                                                        Generar Carta
                                                    </button>

                                                    <button
                                                        className='dropdown-item'
                                                        data-toggle='tooltip'
                                                        data-placement='top'
                                                        title=''
                                                        data-original-title='Eliminar'
                                                        onClick={() => openDeleteModal(template) }>
                                                        Eliminar
                                                    </button>
                                                </Dropdown>
                                            }</td>
                                        </tr>))
                                        : <tr className="tr-shadow"><td colSpan={4}>No hay ninguna plantilla creado.</td></tr>
                                    )
                                }
                            </tbody>
                        </table>

                        {templates?.links && (<Pagination links={templates.links} meta={templates.meta} getData={getTemplates} />)}
                    </div>
                </div>
            </div>
        </div>

        <Modal
            title={`Eliminar plantilla: ${selected?.titulo}`}
            show={showDeleteModal}
            blank={false}
            callback={eliminarTemplate}
            toggle={closeDeleteModal}>
                {
                    deleting 
                    ? <><Loader /></> 
                    : <p className="px-3 pb-3">¿Estás seguro que desea eliminar esta plantilla? (Esta acción no se puede deshacer).</p>
                }
        </Modal>

        <Modal
            title={`Generar Carta`}
            show={showGenerarModal}
            blank={true}
            toggle={closeGenerarModal}>
                <CrearCartaForm defaultTemplate={selected ? {
                    label: selected.titulo,
                    value: selected.id,
                    tipo: selected.tipo,
                }: {}} toggle={closeGenerarModal}></CrearCartaForm>
        </Modal>
    </>;
};

export default Templates;
